// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3C7XG","actionsCol":"EnrolledClinics_actionsCol__eq3Aj"};